<template>
    <TableLayout :permissions="['business:carevent:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="车牌号" prop="plateNos">
                <el-input v-model="searchForm.plateNos" placeholder="请输入车牌号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="姓名/手机号" prop="keyWords">
                <el-input v-model="searchForm.keyWords" placeholder="请输入姓名/手机号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="公司/部门名称" prop="companyName">
                <el-input v-model="searchForm.companyName" placeholder="请输入公司/部门名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="人员类型" prop="memberType">
                <el-select v-model="searchForm.memberType" placeholder="请选择">
                    <el-option label="劳务访客" value="0"></el-option>
                    <el-option label="普通访客" value="1"></el-option>
                    <el-option label="内部人员" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="事件类型" prop="eventType">
                <el-select v-model="searchForm.eventType" placeholder="请选择">
                    <el-option label="入场压线事件" value="771760130"></el-option>
                    <el-option label="入场放行事件" value="771760131"></el-option>
                    <el-option label="出场压线事件" value="771760133"></el-option>
                    <el-option label="出场放行事件" value="771760134"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="起始时间" prop="eventType">
                <el-date-picker
                    @change="seleTime"
                    v-model="time"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-radio-group v-model="searchForm.radio" size="small" @input="changeRadio">
                <el-radio-button label="0">当天</el-radio-button>
                <el-radio-button label="1">近7天</el-radio-button>
                <el-radio-button label="2">近30天</el-radio-button>
            </el-radio-group>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['business:carevent:exportExcel']">
              <li><el-button type="primary"   v-permissions="['business:carevent:sync']" @click="$refs.OperaCarEventHkWindow.open('同步过车记录')">同步</el-button></li>
              <li><el-button type="primary" :loading="isWorking.export" v-permissions="['business:carevent:exportExcel']" @click="exportExcel">导出</el-button></li>
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
            >
                <el-table-column prop="plateNos" label="车牌号" min-width="100px"></el-table-column>
                <el-table-column prop="parkName" label="停车库名称" min-width="100px"></el-table-column>
                <el-table-column prop="gateName" label="出入口名称" min-width="100px"></el-table-column>
                <el-table-column prop="eventTypeName" label="事件类型" min-width="100px"></el-table-column>
                <el-table-column label="出入类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.inoutType === 0">进场</span>
                        <span v-if="row.inoutType === 1">出场</span>
                    </template>
                </el-table-column>
              <el-table-column label="归属用户类型" min-width="100px">
                <template slot-scope="{row}">
                  <span v-if="row.personType === '0'">劳务访客</span>
                  <span v-if="row.personType === '1'">普通访客</span>
                  <span v-if="row.personType === '2'">内部人员</span>
                </template>
              </el-table-column>
              <el-table-column prop="personName" label="姓名" min-width="100px"></el-table-column>
              <el-table-column prop="personPhone" label="手机号" min-width="100px"></el-table-column>
              <el-table-column prop="personCompanyName" label="公司/部门" min-width="100px"></el-table-column>
              <el-table-column label="车牌抓拍图" min-width="100px">
                <template slot-scope="{row}">
                  <div  v-if="row.platePicUrl!=null">
                    <el-image
                        style="width: 80px; height: 80px"
                        :src="row.platePicUrl"
                        :preview-src-list="[row.platePicUrl]">
                    </el-image>
                  </div>
                </template>
              </el-table-column>
                <el-table-column label="抓拍图片" min-width="100px">
                    <template slot-scope="{row}">
                      <div  v-if="row.vehiclePicUrl!=null">
                        <el-image
                            style="width: 80px; height: 80px"
                            :src="row.vehiclePicUrl"
                            :preview-src-list="[row.vehiclePicUrl]">
                        </el-image>
                      </div>
                    </template>
                </el-table-column>
                <el-table-column prop="happenTime" label="事件时间" min-width="100px"></el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>

          <OperaCarEventHkWindow ref="OperaCarEventHkWindow" @success="search()" />
        </template>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaCarEventHkWindow from '@/components/business/OperaCarEventHkWindow'
import { timeForMat } from '@/utils/util'
export default {
  name: 'CarEvent',
  extends: BaseTable,
  components: { TableLayout, Pagination ,OperaCarEventHkWindow},
  data () {
    return {
      // 搜索
      searchForm: {
        eventType: '',
        keyWords: '',
        plateNos: '',
        memberType: '',
        companyName: '',
        startTime: '',
        endTime: '',
        radio: '0'
      },
      time: []
    }
  },
  created () {
    this.config({
      module: '停车场事件推送记录表',
      api: '/business/carEvent',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.changeRadio('0')
    this.search()
  },
  methods: {
    reset () {
      this.$refs.searchForm.resetFields()
      this.searchForm.radio = '0'
      this.changeRadio('0')
      this.time = []
      this.search()
    },
    changeRadio (e) {
      if (e === '0') {
        this.searchForm.startTime = timeForMat(0)[0]
        this.searchForm.endTime = timeForMat(0)[1]
        this.time = timeForMat(0)
      } else if (e === '1') {
        this.searchForm.startTime = timeForMat(6)[0]
        this.searchForm.endTime = timeForMat(6)[1]
        this.time = timeForMat(6)
      } else if (e === '2') {
        this.searchForm.startTime = timeForMat(29)[0]
        this.searchForm.endTime = timeForMat(29)[1]
        this.time = timeForMat(29)
      }
      this.search()
    },
    seleTime (e) {
      this.searchForm.startTime = e[0]
      this.searchForm.endTime = e[1]
      this.searchForm.radio = null
      this.search()
    }
  }
}
</script>
